import controller from './user-controller';
import template from './user.html';

const UserComponent = {
    bindings: {
        clientList: '<',
        currentUser: '<',
        customPermissionList: '<',
        roleList: '<',
        user: '<'
    },
    controller,
    template,
};

export default UserComponent;



// WEBPACK FOOTER //
// ./app/components/user-admin/user/user-component.js